import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { gql, useMutation } from "@apollo/client";
import MuiAlert from "@material-ui/lab/Alert";
import { actions } from "../Auth/_redux/authRedux";

import {
  Card,
  CardActionArea,
  CardMedia,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  CircularProgress,
  ListItemText,
  Grid,
  Button,
  Snackbar,
} from "@material-ui/core";

import { School, ArrowBack } from "@material-ui/icons";
import Scrollspy from "react-scrollspy";

const SAVE_COLLEGE = gql`
  mutation SaveCollegeMutation($saveCollegeCollegeId: String!) {
    saveCollege(collegeId: $saveCollegeCollegeId) {
      success
      message
      code
    }
  }
`;
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export function Navbar(props) {
  const dispatch = useDispatch();

  var { user } = useSelector((state) => state.auth);
  console.log("initial : ", user);
  const [open, setOpen] = React.useState(false);
  const [savedColleges, setSavedColleges] = React.useState(
    (user && user.savedCollegeIds) || []
  );

  const [saveCollege, { loading }] = useMutation(SAVE_COLLEGE, {
    onCompleted(status) {
      var saved = savedColleges;
      saved.push(data.collegeId);
      user.savedCollegeIds = saved;
      console.log("after", user);

      dispatch(actions.requestUser({ user: user }));
      setSavedColleges(saved);
      setOpen(!open);
    },
  });
  const { menuList, data } = props;
  const scrollToRef = (ref) =>
    window.scrollTo({ top: ref.current.offsetTop - 80, behavior: "smooth" });

  const navbarData = {
    website: data.website,
    city: data.city,
    image: data.campusImage,
    address: data.location + ", " + data.zipcode,
  };

  const handleSaveCollege = () => {
    saveCollege({
      variables: {
        saveCollegeCollegeId: data.collegeId,
      },
    });
  };
  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  return (
    <>
      <Card
        className="p-5"
        style={{
          borderRadius: "10px",
        }}
      >
        <Box mb={1}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography
                style={{ cursor: "pointer", color: "grey" }}
                onClick={() => {
                  window.history.go(-1);
                  return false;
                }}
              >
                <ArrowBack /> back
              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                className="text-white"
                onClick={handleSaveCollege}
                disabled={
                  user
                    ? savedColleges
                      ? savedColleges.includes(data.collegeId)
                        ? true
                        : false
                      : false
                    : true
                }
              >
                {loading ? (
                  <CircularProgress
                    size={20}
                    style={{
                      color: "grey",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                  />
                ) : user ? (
                  savedColleges ? (
                    savedColleges.includes(data.collegeId) ? (
                      <Typography
                        style={{ color: "grey", height: "20px", width: "40px" }}
                      >
                        Saved
                      </Typography>
                    ) : (
                      <Typography style={{ height: "20px", width: "40px" }}>
                        Save
                      </Typography>
                    )
                  ) : (
                    <Typography style={{ height: "20px", width: "40px" }}>
                      Save
                    </Typography>
                  )
                ) : (
                  <Typography
                    style={{ color: "grey", height: "20px", width: "40px" }}
                  >
                    Save
                  </Typography>
                )}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <CardActionArea>
          <Box mb={1}>
            <CardMedia
              style={{ height: 150, borderRadius: "10px" }}
              image={navbarData.image}
              title="College Campus"
            />
          </Box>
        </CardActionArea>
        <Box>
          {["website", "city", "address"].map((key, index) => (
            <Box
              key={index}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h6"
                  style={{ fontSize: "1.1rem" }}
                  className="text-capitalize mr-3"
                >
                  {key}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" style={{ color: "grey" }}>
                  {key === "website" ? (
                    <a
                      href={"https://" + navbarData[key]}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {navbarData[key]}
                    </a>
                  ) : (
                    navbarData[key]
                  )}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
        <Box>
          <List>
            <Scrollspy className="p-0" items={Object.keys(menuList)}>
              {Object.keys(menuList).map((item, index) => (
                // <a href={"#" + item.title.toLowerCase().replace(" ", "_")}>
                <ListItem
                  key={index}
                  button
                  onClick={() => {
                    scrollToRef(menuList[item].ref);
                  }}
                >
                  <ListItemIcon>
                    {menuList[item].icon ? menuList[item].icon : <School />}
                  </ListItemIcon>
                  <ListItemText>{menuList[item].title}</ListItemText>
                </ListItem>
                // </a>
              ))}
            </Scrollspy>
          </List>
        </Box>
        <Box>
          <Snackbar
            open={open}
            autoHideDuration={5000}
            color="danger"
            onClose={handleSnackBarClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <Alert
              onClose={handleSnackBarClose}
              style={{ fontSize: "16px" }}
              severity="success"
            >
              {"College saved successfully"}
            </Alert>
          </Snackbar>
        </Box>
      </Card>
    </>
  );
}
